import React from 'react';
import { useSelector } from 'react-redux';

import { DownloadBottom } from '@videoblocks/react-icons';

import AiContentEventFactory from '../../../../../Events/AiContentEventFactory';
import events from '../../../../../Events/Events';
import { Button } from '../../../../../builder-io/storyblocks-design-system/components/atoms/Button/Button';
import { Text } from '../../../../../builder-io/storyblocks-design-system/components/atoms/Text/Text';
import {
  selectJobId,
  selectOutputUrl,
} from '../../../../ContentEdit/ContentEditSlice';
import VideoEditFeedback from './components/VideoEditFeedback';

const VideoEditResult = ({ handleClose, contentId }) => {
  const resultUrl = useSelector(selectOutputUrl);
  const jobId = useSelector(selectJobId);

  return (
    <>
      <Text className="mt-4" fontSize="lg">
        Preview and download your edited video below
      </Text>

      <Text fontSize="base" fontWeight="regular" className="text-center">
        Once you close this window, you will not be able to access your video
        again. Please be sure to download your generation to save it.
      </Text>

      <Button
        iconPrefix={<DownloadBottom />}
        variant="primary"
        className="my-4 "
        buttonClassName="flex gap-2 items-center"
        onClick={() => {
          const aiContentDownloadEvent =
            AiContentEventFactory.createDownloadEvent(contentId);
          events.produce(aiContentDownloadEvent);
          const downloadUrl = `/api/video/generate-edit/download?jobId=${jobId}`;

          const link = document.createElement('a');
          link.href = downloadUrl;
          link.download = 'video.mp4';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }}
      >
        Download
      </Button>

      <div className="w-full h-1/3 mb-4">
        <video
          src={resultUrl}
          className="w-full h-full object-contain rounded-lg"
          preload="metadata"
          controls
          autoPlay
          muted
        />
      </div>
      <VideoEditFeedback handleClose={handleClose} contentId={contentId} />
    </>
  );
};

export default VideoEditResult;
